export const state_Wide_Base = [];
